export default __webpack_public_path__ + "static/media/left.58467e9e.svg";